import { Fragment } from 'react';

import useOUAdminEntryContextView from './UseOUAdminEntryContextView';

import LeftArrowIcon from '@usas/ui-web/components/icons/LeftArrowIcon';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PageNotFound from '@usas/ui-web/components/PageNotFound';

import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const OUAdminEntryContextView = ({ children }) => {
  const {
    omeMeetOrgUnitEntryInfoState,
    omeMeetOrgUnitEntryState,
    backToLabel,
    onBackClicked,
  } = useOUAdminEntryContextView();

  if (!omeMeetOrgUnitEntryState || Object.keys(omeMeetOrgUnitEntryState.objData).length === 0 ||
    !omeMeetOrgUnitEntryInfoState || Object.keys(omeMeetOrgUnitEntryInfoState.objData).length === 0) {
    return omeMeetOrgUnitEntryState.isObjLoading === false
      ? (
        <Fragment>
          <div className="row usas-extra-bottom-margin">
            <div className="col-xs-12">
              <button className={global.BackToSearchButton}
                type="button"
                onClick={onBackClicked}>
                <LeftArrowIcon />  {backToLabel}
              </button>
            </div>
          </div>
          <div className="row usas-extra-bottom-margin">
            <div className="col-xs-12">
              <PageNotFound />
            </div>
          </div>
        </Fragment>
      ) : (
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <PopUpModal
              widthPct={50}
              maxWidth={250}
              title={Constants.LOADING_MSG}
              displayPopUp={true} />
          </div>
        </div>
      );
  }

  return (
    <Fragment>
      {children}
    </Fragment >
  );
};

export default OUAdminEntryContextView;